<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  addCountry,
  getCountry,
  getDetails,
  updateCountry,
  deleteCountry
} from "@/api/system/country";
import { getTimezone } from "@/api/system/timezone";
import { getCurrency } from "@/api/finance/currency";

import cTable from "@/base/common/index";
export default {
  name: "country",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getCountry,
        getDetails,
        deleteCountry,
        addCountry,
        updateCountry,
        getTimezone,
        getCurrency
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,
              transfer: true,
              sticky: true,
              "sticky-distance": 10,
              "reset-drag-position": true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              cn_title: [
                {
                  required: true,
                  message: "chinese name cannot be empty",
                  trigger: "blur"
                }
                // {
                //   max: 55,
                //   message: "Please enter maximum length 55",
                //   trigger: "blur",
                // },
              ],
              title: [
                {
                  required: true,
                  message: "country_name cannot be empty",
                  trigger: "blur"
                }
                // {
                //   max: 55,
                //   message: "Please enter maximum length 55",
                //   trigger: "blur",
                // },
              ],
              code: [
                {
                  required: true,
                  message: "Cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 2,
                  max: 2,
                  message: "The length must be 2",
                  trigger: "blur"
                }
              ],
              country_code: [
                {
                  required: true,
                  type: "string",
                  message: "Cannot be empty",
                  trigger: "blur"
                },
                {
                  type: "string",
                  max: 4,
                  message: "Please enter maximum length 4",
                  trigger: "blur"
                }
              ],
              currency_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the currency",
                  trigger: "change"
                }
              ],
              timezone_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the TimeZone",
                  trigger: "change"
                }
              ],
              country_code_type: [
                {
                  required: true,
                  message: "Please select the code_type",
                  trigger: "change"
                }
              ],
              country_code_validation: [
                {
                  required: true,
                  message: "Cannot be empty",
                  trigger: "change"
                }
              ],
              min_length: [
                {
                  required: true,
                  type: "number",
                  message: "Cannot be empty",
                  trigger: "blur"
                }
              ],
              max_length: [
                {
                  required: true,
                  validator(rule, value, callback) {
                    if (Number(value) < Number(this.formData.min_length)) {
                      callback(
                        new Error(
                          "Cannot be less than the minimum number length"
                        )
                      );
                    } else {
                      callback();
                    }
                  },
                  type: "number",
                  trigger: "change"
                }
              ],
              allow_depart: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the allow_depart",
                  trigger: "change"
                }
              ],
              allow_arrive: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the allow_arrive",
                  trigger: "change"
                }
              ],
              language: [
                {
                  required: true,
                  message: "Please select the language",
                  trigger: "change"
                }
              ],
              customer_report: [
                {
                  required: true,
                  message: "Please select the customer_report",
                  trigger: "change"
                }
              ],
              status: [
                {
                  required: true,
                  message: "Please select the status",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { cn_title: 12, title: 12 },
            { code: 12, currency_id: 12 },
            { timezone_id: 12, country_code: 12 },
            { country_code_type: 12, country_code_validation: 12 },
            { min_length: 12, max_length: 12 },
            { allow_depart: 12, allow_arrive: 12 },
            { customer_report: 12, status: 12 },
            { language: 12 }
          ],
          fields: [
            {
              name: () => this.$t("cnName"),
              key: "cn_title",
              component: "Input",
              placeholder() {
                return this.$t("select") + this.$t("cnName");
              }
            },
            {
              name: () => this.$t("countryName"),
              key: "title",
              component: "Input",

              placeholder() {
                return this.$t("select") + this.$t("countryName");
              }
            },
            {
              name: () => this.$t("countryCode"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("select") + this.$t("countryCode");
              }
            },
            {
              name: () => this.$t("countryCurrency"),
              key: "currency_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryCurrency");
              },
              config: {
                label: "code",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("countryTimezone"),
              key: "timezone_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryTimezone");
              },
              options: [],
              config: { label: "format", value: "id" },

              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getTimezone")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("countryZone"),
              key: "country_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("countryZone");
              },
              options: [],
              config: { label: "title", value: "id" }
            },
            {
              name: () => this.$t("code_rules") + this.$t("country_code_type"),
              key: "country_code_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("country_code_type");
              },
              options: [
                { label: "RANGE", value: "RANGE" },
                { label: "PATTERN", value: "PATTERN" },
                { label: "CALLBACK", value: "CALLBACK" }
              ],
              methods: {
                "on-change"({ formData }) {
                  formData.max_length = formData.min_length = 1;
                  formData.country_code_validation = "";
                }
              }
            },
            {
              name: () =>
                this.$t("code_rules") + this.$t("country_code_validation"),
              key: "country_code_validation",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("code_rules") +
                  this.$t("country_code_validation")
                );
              },
              show({ formData }) {
                return (
                  formData.country_code_type != "" &&
                  formData.country_code_type != "RANGE"
                );
              }
            },
            {
              name: () => this.$t("numMin") + this.$t("num_lengths"),
              key: "min_length",
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 1
              },
              placeholder() {
                return (
                  this.$t("select") + this.$t("numMin") + this.$t("num_lengths")
                );
              },
              default: 1,
              show({ formData }) {
                return formData.country_code_type == "RANGE";
              }
            },
            {
              name: () => this.$t("numMax") + this.$t("num_lengths"),
              key: "max_length",
              component: "InputNumber",
              bind: {
                min: 1,
                style: "width:100%"
              },
              default: 1,
              placeholder() {
                return (
                  this.$t("select") + this.$t("numMax") + this.$t("num_lengths")
                );
              },
              show({ formData }) {
                return formData.country_code_type == "RANGE";
              }
            },
            {
              name: () => this.$t("is_goods") + this.$t("allow_depart"),
              key: "allow_depart",
              component: "Radio",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("is_goods") +
                  this.$t("allow_depart")
                );
              },
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("is_goods") + this.$t("allow_arrive"),
              key: "allow_arrive",
              component: "Radio",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("is_goods") +
                  this.$t("allow_arrive")
                );
              },
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("exlType");
              },
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("language"),
              key: "language",
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("language");
              },
              options: [
                { label: "arab", value: "arab" },
                { label: "hebrew", value: "hebrew" }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("customer_report"),
              key: "customer_report",
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("customer_report");
              },
              options: [
                { label: this.$t("YES"), value: "yes" },
                { label: this.$t("NO"), value: "no" }
              ],
              bind: {
                border: true
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          // {
          //   key: this.$t("exlType"),
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("status");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('enable'), value: "ENABLE" },
          //     { label: this.$t('disable'), value: "DISABLE" }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 142
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "addCountry";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("cnName"),
          key: "cn_title",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("countryName"),
          key: "title",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("countryCode"),
          key: "code",
          minWidth: 80
        },
        {
          name: () => this.$t("countryCurrency"),
          key: "currency_code",
          minWidth: 80,
          methods: {
            render({ row }) {
              return row.currency ? row.currency.code : "-";
            }
          }
        },

        {
          name: () => this.$t("countryTimezone"),
          minWidth: 80,
          key: "timezone",
          methods: {
            render({ value }) {
              return value ? value.format : "-";
            }
          }
        },
        {
          name: () => this.$t("countryZone"),
          key: "country_code",
          minWidth: 80
        },
        {
          name: () => this.$t("code_rules") + this.$t("country_code_type"),
          key: "country_code_type",
          minWidth: 80
        },

        {
          name: () =>
            this.$t("code_rules") + this.$t("country_code_validation"),
          key: "country_code_validation",
          minWidth: 80
        },
        {
          name: () => this.$t("numMin") + this.$t("num_lengths"),
          key: "min_length",
          minWidth: 90
        },
        {
          name: () => this.$t("numMax") + this.$t("num_lengths"),
          key: "max_length",
          minWidth: 90
        },
        {
          name: () => this.$t("is_goods") + this.$t("allow_depart"),
          key: "allow_depart",
          minWidth: 90,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("is_goods") + this.$t("allow_arrive"),
          key: "allow_arrive",

          minWidth: 90,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("exlType"),
          key: "status",
          minWidth: 110,
          methods: {
            render({ value }) {
              return this.$t(value);
            }
          }
        },
        {
          type: "btns",
          width: 80,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 143
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   bind: {
            //     type: "error"
            //   }
            // }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "updateCountry";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("deleteCountry", row.id).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    // this.header.searchs.forEach(async item => {
    //   if (item.key === "currency_code")
    //     item.options = (await getCurrency()).data.payload.rows;
    //   if (item.key === "timezone_id")
    //     item.options = (await getTimezone()).data.payload.rows;
    // });
  }
};
</script>
